var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgClickNcollect = function SvgClickNcollect(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 11 10",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3A3A3A",
    strokeLinecap: "round",
    d: "m1.438 1.34 1.5 1.215M4.377.504 4.65 2.12M2.629 4.316.875 4.113"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3A3A3A",
    d: "m6.125 8.456 1.125-1.91 1.875-1.04-4.5-1.389z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3A3A",
    d: "M8.973 8.682a.5.5 0 1 0 .68-.734zM6.91 6.773l2.063 1.91.68-.735L7.59 6.04z"
  })));
};
export default SvgClickNcollect;